import React from 'react';
import image from '../images/tech.png';
import style from '../css/Component2.module.css';

function Seven() {
	return (
		<div className={style.container}>
			<img src={image} alt="" className={style.image1} />

			<div className={style.box}>
				<h1 className={style.header}>
					India's Trusted Doorstep Service Provider
				</h1>
				<p className={style.desc}>
					HomeTech Repair is a trusted service platform specializing in home
					appliance repairs. Our team of skilled technicians is equipped to handle repairs smoothly.
				</p>
			</div>
		</div>
	);
}

export default Seven;
